import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { loadIndividualProducts, selectIndividualProducts } from 'src/app/shareModule/states/individual-all-product';

@Injectable({
    providedIn: 'root'
})
export class IndividualProductsResolver implements Resolve<any> {

    constructor(private store: Store, private local: LocalServiceService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return of([])
        const subRegionId = this.local.getUser()?.region || '';
        this.store.dispatch(loadIndividualProducts({ categoryId: "", subRegionId, search: '' }));
        return this.store.pipe(select(selectIndividualProducts));
    }
}
